module.exports = {"TXTWCL_N0_time":{"id":"TXTWCL_N0_time","defaultMessage":"{0} Time"},"TXTWCL_N0_times":{"id":"TXTWCL_N0_times","defaultMessage":"{0} Times"}}